export default {
  init() {
     //MAPS API : x08 : AIzaSyBvZjA65RoOIjNUKPDlEWk5R0vyvKvs0-Q
    $('.property-listing').on('click', function() {
      window.location.href = $(this).data("url");
    });

    $('.filter-all').on('click', function(e) {
      e.preventDefault();
      $(".filter-all").toggleClass('filtered');
      filterResults();
    });
    
    $('.list-button').on('click', function(e) {
      if($('.list-button').hasClass('active')) return false;
      e.preventDefault();
      $('.list-button').addClass('active');
      $('.map-button').removeClass('active');
      $('.property-results-map').addClass('hidden');
      
      $('.property-results-images').toggleClass('col-lg-12');
      $('.property-listing').toggleClass('col-lg-6');
      $('.property-listing').toggleClass('col-lg-3');
    });
    
    $('.map-button').on('click', function(e) {
      if($('.map-button').hasClass('active')) return false;
      e.preventDefault();
      $('.map-button').addClass('active');
      $('.list-button').removeClass('active');
      $('.property-results-map').removeClass('hidden');
      
      $('.property-results-images').toggleClass('col-lg-12');
      $('.property-listing').toggleClass('col-lg-6');
      $('.property-listing').toggleClass('col-lg-3');
    });

    $('.clear-search').on('click', function() {
      $('.filter-all').removeClass('filtered');
      $('.checkbox-dropdown button').removeClass('active');
      $('#search-query').val('');
      $('input[type="checkbox"]').attr('checked', false);
      filterResults();
    });
    
//     window.setTimeout(function() {
//       $('.property-results .property-results-images .row').css('overflow', 'auto');
//     });

    $('.checkbox-dropdown button').on('click', function(e) {
      e.preventDefault();
      const active = $(this).hasClass('active');
      $('.checkbox-dropdown button').removeClass('active');
      if (active) {
        $(this).removeClass('active');
      } else {
        $(this).addClass('active');
      }
    });
    
    $('.checkbox-dropdown fieldset').on('mouseout', function(event) {
      var e = event.toElement || event.relatedTarget;
      if (e && (e.parentNode == this || e == this || e.parentNode.parentNode == this)) {
          return;
      }
      $('.checkbox-dropdown button').removeClass('active');
    });

    $('input[type="checkbox"]').change(function() {
      filterResults();
    });

    $('#search-form').on('keyup keypress', function(e) {
      var keyCode = e.keyCode || e.which;
      if (keyCode === 13) {
        filterResults();
        e.preventDefault();
        return false;
      }
    });

     $( "#filter-lease" ).click(function() {
      $( "#filter-purchase" ).removeClass('active');
      $(this).addClass('active');
      $('#filter').val("lease");
      filterResults();
    });

    $( "#filter-purchase" ).click(function() {
      $( "#filter-lease" ).removeClass('active');
      $(this).addClass('active');
      $('#filter').val("sale");
      filterResults();
    });

    $( "#search-submit" ).click(function(e) {
      filterResults();
      e.preventDefault(true);
      return false;
    });

    $(".property-listing").mouseenter(function() {
      window.map.panTo(new window.google.maps.LatLng($(this).data("lat"),$(this).data("long")));
      if (window.markers[$(this)[0].getAttribute('data-index')]) {
        window.markers[$(this)[0].getAttribute('data-index')].setIcon('../map-icon-hover.png');
      }
    });
    
    $(".property-listing").mouseleave(function() {
       if (window.markers[$(this)[0].getAttribute('data-index')]) {
        window.markers[$(this)[0].getAttribute('data-index')].setIcon('../map-icon.png');
       }
    });

    
    filterResults();

    
    
    function filterResults() {

      var filterLease =  $(".filter-lease").hasClass('active') ? true : false;
      
      $(".property-listing").each(function() {
        if($("#search-query").val().trim().length > 0 && $(this).data("search").toLowerCase().indexOf($("#search-query").val().toLowerCase()) == -1 ) {
          $(this).hide();
        } else {
          $(this).show();
        }
      });
      
      
        
      if(filterLease) {
        $(".property-listing").each(function() {
            if(!$(this).data("for-lease")) {
              $(this).hide();
            }
        });
      } else {
        $(".property-listing").each(function() {
            if(!$(this).data("for-sale")) {
              $(this).hide();
            }
        });        
      }
      
      /* FILTER TYPE */
      if($(".filter-type:checked").length > 0) {
        $(".filter-type button").addClass('filtered');
        $(".property-listing").not($('.filter-type:checked').map(function() {return '.' + this.value;}).get().join(',')).hide();
      } else {
        $(".filter-type button").removeClass('filtered');
      }
      /* FILTER CITY */
      if($(".filter-city:checked").length > 0) {
        $(".filter-city button").addClass('filtered');
        $(".filter-city:not(:checked)").each(function() {
          $('.property-listing[data-city="' + $(this).val() + '"]').hide();
        });
      } else {
        $(".filter-city button").removeClass('filtered');
      }

      /* FILTER SIZE */
      if($(".filter-size:checked").length > 0) {
        $(".filter-size button").addClass('filtered');
        $(".property-listing").not($('.filter-size:checked').map(function() {return '.' + this.value;}).get().join(',')).hide();
      } else {
        $(".filter-size button").removeClass('filtered');
      }

       /* FILTER BROKER */
      if($(".filter-broker:checked").length > 0) {
        $(".filter-broker button").addClass('filtered');
        $(".property-listing").not($('.filter-broker:checked').map(function() {return '.' + this.value;}).get().join(',')).hide();
      } else {
        $(".filter-broker button").removeClass('filtered');
      }

      /* eslint-disable */
      /* FILTER ALL */
      if(!$('.filter-all').hasClass('filtered')) {
        $(".property-listing[data-available='0']").each(function() {
            if($("#search-query").val().trim().length > 0 && $(this).data("search").toLowerCase().indexOf($("#search-query").val().toLowerCase()) > -1 ) { 
            } else {
              $(this).hide();
            }
        });
      }
     

      if ($('.property-listing:visible').length === 0) {
        $("#results-message").html('<h3>No results were found.  Please adjust your search and try again.</h3>').show();
      } else {
        $("#results-message").hide();
      }
            
      return false;
    }

    initMap();

    function initMap() {

      window.map = new window.google.maps.Map(document.getElementById('map'), {
        center: {lat: 47.6901, lng: -122.2905},
        zoom: 12,
        zoomControlOptions: {
          position: window.google.maps.ControlPosition.LEFT_TOP,
        },
        mapTypeControl: false,
        streetViewControl: false,
        fullscreenControl: false,

        styles: [
          {"elementType": "geometry", "stylers": [{"color": "#1d2c4d"}] },
          {"elementType": "labels.text.fill","stylers": [{"color": "#8ec3b9"}]},
          {"elementType": "labels.text.stroke","stylers": [{"color": "#1a3646"}]},
          {"featureType": "administrative","elementType": "geometry","stylers": [{"visibility": "off"}]},
          {"featureType": "administrative.country","elementType": "geometry.stroke","stylers": [{"color": "#4b6878"}]},
          {"featureType": "administrative.land_parcel","elementType": "labels.text.fill","stylers": [{"color": "#64779e"}]},
          {"featureType": "administrative.province","elementType": "geometry.stroke","stylers": [{"color": "#4b6878"}]},
          {"featureType": "landscape","elementType": "geometry.fill","stylers": [{"color": "#3e5962"}]},
          {"featureType": "poi","stylers": [{"visibility": "off"}]},
          {"featureType": "poi","elementType": "geometry","stylers": [{"color": "#283d6a"}]},
          {"featureType": "poi","elementType": "labels.text.fill","stylers": [{"color": "#6f9ba5"}]},
          {"featureType": "poi","elementType": "labels.text.stroke","stylers": [{"color": "#1d2c4d"}]},
          {"featureType": "road", "elementType": "geometry","stylers": [{"color": "#304a7d"}]},
          {"featureType": "road","elementType": "geometry.fill","stylers": [{"color": "#138c83"},{"weight": 5}]},
          {"featureType": "road","elementType": "geometry.stroke","stylers": [{"visibility": "off"}]},
          {"featureType": "road", "elementType": "labels.icon", "stylers": [ { "visibility": "off" } ] },
          {"featureType": "road", "elementType": "labels.text.fill", "stylers": [ { "color": "#7eada7" } ] },
          {"featureType": "road", "elementType": "labels.text.stroke", "stylers": [ { "color": "#1f3f4a" } ] },
          {"featureType": "road.arterial", "stylers": [ { "visibility": "off" } ] },
          {"featureType": "road.highway", "elementType": "labels", "stylers": [ { "visibility": "off" } ] },
          {"featureType": "road.local", "stylers": [ { "visibility": "off" } ] },
          {"featureType": "transit", "stylers": [ { "visibility": "off" } ] },
          {"featureType": "transit", "elementType": "labels.text.fill", "stylers": [ { "color": "#98a5be" } ] },
          {"featureType": "transit", "elementType": "labels.text.stroke", "stylers": [ { "color": "#1d2c4d" } ] },
          {"featureType": "transit.line", "elementType": "geometry.fill", "stylers": [ { "color": "#283d6a" } ] },
          {"featureType": "transit.station", "elementType": "geometry", "stylers": [ { "color": "#3a4762" } ] },
          {"featureType": "water", "elementType": "geometry", "stylers": [ { "color": "#1f3f4a" } ] },
          {"featureType": "water", "elementType": "labels.text.fill", "stylers": [ { "color": "#4e6d70" } ] },
        ],
      });

/* eslint-disable */
      var moreMapControlDiv = document.createElement('div');
      var moreMapControl = new MoreMapControl(moreMapControlDiv, window.map);

      var icons = {
        property: {
          icon: '../map-icon.png',
          originalicon: '../map-icon.png',
          hovericon: '../map-icon-hover.png',
        },
      };

         
      var bounds = new window.google.maps.LatLngBounds();
      window.markers = [];
      window.properties.forEach(function(property) {
        var marker = new window.google.maps.Marker({
          position: new window.google.maps.LatLng(property.lat, property.long),
          icon: icons[property.type].icon,
          hovericon: icons[property.type].hovericon,
          id: property.id,
          map: window.map,
        });
        
        window.markers.push(marker);
        
        bounds.extend(marker.position);
        
        var currentInfoWindow = null;
        var currentPropertyHref = null;

        window.google.maps.event.addListener(marker, 'mouseover', function() {
          this.setIcon(this.hovericon);
          
          $('.property-results-images .row').animate({
              //scrollTop: $('[data-property-id="' + this.id  + '"]').offset().top,
            }, 500);
          var propertyImage = $('.property-listing[data-property-id="' + marker.id + '"] .listing-image').css('background-image');
          var propertyName = $('.property-listing[data-property-id="' + marker.id + '"] .property-name').html();
          var propertyLocation = $('.property-listing[data-property-id="' + marker.id + '"] .property-city').html();
          var propertyPrice = $('.property-listing[data-property-id="' + marker.id + '"] .property-price').html();
          currentPropertyHref = $('.property-listing[data-property-id="' + marker.id + '"]')[0].getAttribute("data-url");
          currentInfoWindow = new window.google.maps.InfoWindow({
            content: "<div id='map-info-card'><div class='property-image' style='background-image: " + propertyImage.toString() + "'></div><div class='property-details'><ul><li>" + propertyLocation + "</li><li><b>" + propertyName + "</b></li><li><small>" + propertyPrice + "</small></li></div></div>",
            height : 60,
          });
          
            
          currentInfoWindow.open(window.map, marker);       
        });

        window.google.maps.event.addListener(marker, 'mouseout', function() {
          this.setIcon('../map-icon.png');
          currentInfoWindow.close();
        });
        
        window.google.maps.event.addListener(marker, 'click', function() {
          window.location.href = currentPropertyHref;
        });

      });
      //window.map.fitBounds(bounds);

      moreMapControlDiv.index = 1;
      window.map.controls[window.google.maps.ControlPosition.TOP_RIGHT].push(moreMapControlDiv);

    }

    function MoreMapControl(controlDiv) {
      var controlUI = document.createElement('div');
      controlUI.setAttribute("id", "more-map");
      controlUI.style.backgroundColor = '#fff';
      controlUI.style.border = '2px solid #fff';
      controlUI.style.borderRadius = '3px';
      controlUI.style.boxShadow = '0 2px 6px rgba(0,0,0,.3)';
      controlUI.style.cursor = 'pointer';
      controlUI.style.marginRight = '11px';
      controlUI.style.marginTop = '11px';
      controlUI.style.textAlign = 'center';
      controlUI.title = 'Click to view a larger Map';
      controlDiv.appendChild(controlUI);

      var controlText = document.createElement('div');
      controlText.style.color = 'rgb(25,25,25)';
      controlText.style.fontFamily = 'Roboto,Arial,sans-serif';
      controlText.style.fontSize = '16px';
      controlText.style.lineHeight = '38px';
      controlText.style.paddingLeft = '5px';
      controlText.style.paddingRight = '5px';
      controlText.innerHTML = 'More map';
      controlUI.appendChild(controlText);

      controlUI.addEventListener('click', function() {
          $("#more-map div").text($("#more-map div").text() == 'More map' ? 'Less map' : 'More map');
          $('.property-results-map').toggleClass('order-lg-1');
        
          $('.property-results-map').toggleClass('col-lg-6');
          $('.property-results-map').toggleClass('col-lg-12');
        
          $('.property-results-images').toggleClass('col-lg-6');
          $('.property-results-images').toggleClass('col-lg-12');
          
          $('.property-listing').toggleClass('col-lg-6');
          $('.property-listing').toggleClass('col-lg-3');
      });
    }
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};
  